

module.exports = __webpack_require__.stylable.create(
    "ThreeDotsLoader1079831836",
    {"classes":{"root":"ThreeDotsLoader1079831836__root","dots":"ThreeDotsLoader1079831836__dots"},"vars":{},"stVars":{"DefaultColor":"\"color(color-5)\"","Color":"--overridable","UsedColor":"\"color(fallback(--overridable, color(color-5)))\"","DotSize":"6px","SpaceSize":"4px"},"keyframes":{"pulse":"ThreeDotsLoader1079831836__pulse"}},
    "",
    1,
    "ThreeDotsLoader1079831836",
    null
);
